import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.case05.about-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  accordionItem1Title: {
    id: `${PREFIX}.accordionItem1Title`,
  },
  description: {
    id: `${PREFIX}.description`,
  },
  accordionItem2Title: {
    id: `${PREFIX}.accordionItem2Title`,
  },
  accordionItem2Description: {
    id: `${PREFIX}.accordionItem2Description`,
  },
  galleryDescription1: {
    id: `${PREFIX}.galleryDescription.1`,
  },
  galleryDescription2: {
    id: `${PREFIX}.galleryDescription.2`,
  },
  link: {
    id: `${PREFIX}.link`,
  },
});
